import {
  AddNewConversationAction,
  AddNewConversationPayload,
  AddNewQuestionAction,
  AddNewQuestionPayload,
  ClearStreamingAnswerChunksAction,
  DeleteConversationAction,
  DeleteConversationPayload,
  EditConversationNameAction,
  EditConversationNamePayload,
  EditQuestionAction,
  EditQuestionPayload,
  GetConversationsAction,
  GetConversationsPayload,
  GetDetailConversationAction,
  GetDetailConversationPayload,
  GetLatestConversationAction,
  ResetDataAction,
  SetTimeOutForFinalAnswerAction,
  SetTimeOutForFinalAnswerPayload,
  UpdateConversationsAction,
  UpdateConversationsPayload,
  UpdateCurrentConversationAction,
  UpdateCurrentConversationDataAction,
  UpdateCurrentConversationDataPayload,
  UpdateCurrentConversationPayload,
  UpdateCurrentQuestionAction,
  UpdateCurrentQuestionPayload,
  UpdateLimitStatusAction,
  UpdateLimitStatusPayload,
  UpdateNewAnswerAction,
  UpdateNewAnswerChunkPayload,
  UpdateNewAnswerPayload,
  UpdateNewQuestionAction,
  UpdateNewQuestionPayload,
  UpdateNewStreamingAnswerChunksAction,
  UpdateProcessConversationIdAction,
  UpdateProcessConversationIdPayload,
  UpdateSelectedCitationAction,
  UpdateSelectedCitationPayload,
  UpdateSelectedModelIdAction,
  UpdateSelectedModelIdPayload,
  UpdateStatusAction,
  UpdateStatusPayload,
  UpdateStreamingChunkStatusAction,
  UpdateStreamingChunkStatusPayload,
  UpdateViewModeAction,
  UpdateViewModePayload,
} from 'types/actions/conversation';

import { conversationConstant } from '../actionTypes';

export const getConversations = (payload?: GetConversationsPayload): GetConversationsAction => ({
  type: conversationConstant.GET_CONVERSATIONS,
  payload,
});

export const updateConversations = (
  payload: UpdateConversationsPayload
): UpdateConversationsAction => ({
  type: conversationConstant.UPDATE_CONVERSATIONS,
  payload,
});

export const editConversationName = (
  payload: EditConversationNamePayload
): EditConversationNameAction => ({
  type: conversationConstant.EDIT_CONVERSATION_NAME,
  payload,
});

export const deleteConversation = (
  payload: DeleteConversationPayload
): DeleteConversationAction => ({
  type: conversationConstant.DELETE_CONVERSATION,
  payload,
});

export const updateStatus = (payload: UpdateStatusPayload): UpdateStatusAction => ({
  type: conversationConstant.UPDATE_STATUS,
  payload,
});

export const updateCurrentQuestion = (
  payload: UpdateCurrentQuestionPayload
): UpdateCurrentQuestionAction => ({
  type: conversationConstant.UPDATE_CURRENT_QUESTION,
  payload,
});

export const updateCurrentConversationData = (
  payload: UpdateCurrentConversationDataPayload
): UpdateCurrentConversationDataAction => ({
  type: conversationConstant.UPDATE_CURRENT_CONVERSATION_DATA,
  payload,
});

export const updateCurrentConversation = (
  payload: UpdateCurrentConversationPayload
): UpdateCurrentConversationAction => ({
  type: conversationConstant.UPDATE_CURRENT_CONVERSATION,
  payload,
});

export const updateProcessConversationId = (
  payload: UpdateProcessConversationIdPayload
): UpdateProcessConversationIdAction => ({
  type: conversationConstant.UPDATE_PROCESS_CONVERSATION_ID,
  payload,
});

export const getLatestConversation = (): GetLatestConversationAction => ({
  type: conversationConstant.GET_LATEST_CONVERSATION,
});

export const getDetailConversation = (
  payload: GetDetailConversationPayload
): GetDetailConversationAction => ({
  type: conversationConstant.GET_DETAIL_CONVERSATION,
  payload,
});

export const addNewQuestion = (payload: AddNewQuestionPayload): AddNewQuestionAction => ({
  type: conversationConstant.ADD_NEW_QUESTION,
  payload,
});

export const editQuestion = (payload: EditQuestionPayload): EditQuestionAction => ({
  type: conversationConstant.EDIT_QUESTION,
  payload,
});

export const updateNewQuestion = (payload: UpdateNewQuestionPayload): UpdateNewQuestionAction => ({
  type: conversationConstant.UPDATE_NEW_QUESTION,
  payload,
});

export const addNewConversation = (
  payload: AddNewConversationPayload
): AddNewConversationAction => ({
  type: conversationConstant.ADD_NEW_CONVERSATION,
  payload,
});

export const updateSelectedCitation = (
  payload: UpdateSelectedCitationPayload
): UpdateSelectedCitationAction => ({
  type: conversationConstant.UPDATE_SELECTED_CITATION,
  payload,
});

export const updateNewAnswer = (payload: UpdateNewAnswerPayload): UpdateNewAnswerAction => ({
  type: conversationConstant.UPDATE_NEW_ANSWER,
  payload,
});

export const updateViewMode = (payload: UpdateViewModePayload): UpdateViewModeAction => ({
  type: conversationConstant.UPDATE_VIEW_MODE,
  payload,
});

export const updateLimitStatus = (payload: UpdateLimitStatusPayload): UpdateLimitStatusAction => ({
  type: conversationConstant.UPDATE_LIMIT_STATUS,
  payload,
});

export const resetData = (): ResetDataAction => ({
  type: conversationConstant.RESET_DATA,
});

export const updateProcessingStreamingChunkStatus = (
  payload: UpdateStreamingChunkStatusPayload
): UpdateStreamingChunkStatusAction => ({
  type: conversationConstant.UPDATE_PROCESSING_STREAMING_CHUNK_STATUS,
  payload,
});

export const updateNewStreamingAnswerChunks = (
  payload: UpdateNewAnswerChunkPayload
): UpdateNewStreamingAnswerChunksAction => ({
  type: conversationConstant.UPDATE_NEW_STREAMING_ANSWER_CHUNKS,
  payload,
});

export const clearStreamingAnswerChunks = (): ClearStreamingAnswerChunksAction => ({
  type: conversationConstant.CLEAR_STREAMING_ANSWER_CHUNKS,
});

export const setTimeOutForFinalAnswer = (
  payload: SetTimeOutForFinalAnswerPayload
): SetTimeOutForFinalAnswerAction => ({
  type: conversationConstant.SET_TIMEOUT_FOR_FINAL_ANSWER,
  payload,
});

export const updateSelectedModelId = (
  payload: UpdateSelectedModelIdPayload
): UpdateSelectedModelIdAction => ({
  type: conversationConstant.UPDATE_SELECTED_MODEL_ID,
  payload,
});
